import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "@b2b/services";
import { Button } from "@b2b/ui-components";
import { MessageCircle, Mail, Package, Store } from "lucide-react";

export const WelcomeHeader = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [greeting, setGreeting] = useState<string>("Welcome back");

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const meResponse = await authService.getMe();

        if (meResponse.success && meResponse.user) {
          const user = meResponse.user;
          const name =
            user.firstName && user.lastName
              ? `${user.firstName} ${user.lastName}`
              : user.firstName || user.email?.split("@")[0] || "User";
          setUserName(name);
        }

        const hour = new Date().getHours();
        if (hour < 12) {
          setGreeting("Good morning");
        } else if (hour < 17) {
          setGreeting("Good afternoon");
        } else {
          setGreeting("Good evening");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        setUserName("User");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleChatClick = () => {
    const fullUrl = `${window.location.origin}/chat`;
    window.open(fullUrl, "_blank", "noopener,noreferrer");
  };

  if (loading) {
    return (
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="h-8 w-64 bg-gray-200 rounded animate-pulse mb-2" />
          <div className="h-4 w-96 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900 tracking-tight">
          {greeting}, {userName}
        </h1>
        <p className="text-sm text-gray-500 mt-0.5">
          Your products, enquiries, and storefront at a glance
        </p>
      </div>
      <div className="flex flex-wrap gap-2 w-full sm:w-auto">
        <Button
          variant="outline"
          onClick={() => navigate("/seller/products/list")}
          className="flex items-center gap-2"
        >
          <Package className="h-4 w-4" />
          Products
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate("/seller/enquiries")}
          className="flex items-center gap-2"
        >
          <Mail className="h-4 w-4" />
          Enquiries
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate("/seller/store_front")}
          className="flex items-center gap-2"
        >
          <Store className="h-4 w-4" />
          Storefront
        </Button>
        <Button
          variant="outline"
          onClick={handleChatClick}
          className="flex items-center gap-2"
        >
          <MessageCircle className="h-4 w-4" />
          Chat
        </Button>
      </div>
    </div>
  );
};
